
import { motion } from "framer-motion";
import image from "../../assets/smart-school.jpeg";
import smart_pdf from "../../assets/QS_Smart.pdf";
import { Link } from "react-router-dom";


const FeatureValue1 = () => {

  
  return (
    <div className="w-full bg-[#00294b] flex justify-center items-center sm:py-[5rem] pt-[4rem]">
      
      <div className="container flex lg:flex-row flex-col items-center justify-center gap-4 px-4 sm:px-0">
        {/* Text on left */}
        <motion.div
          initial={{ opacity: 0.5, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false }}
          className="lg:w-1/2 w-full flex flex-col gap-4 lg:items-start items-center justify-center mt-[2rem] lg:mt-0 sm:order-1 order-2"
        >
          <h2 className="lg:text-5xl text-2xl lg:text-start text-center  text-[#22beff] font-bold">
            QS স্মার্ট স্কুল ফ্র্যাঞ্চাইজি
           
          </h2>

          <h2 className="lg:text-xl text-base text-justify text-white font-medium">
            <span className="text-[#bfbfbf] ">
              QS Academy পরিচালিত QS স্মার্ট স্কুল ফ্র্যাঞ্চাইজি একটি আধুনিক, Outcome-Based Education (OBE) ভিত্তিক শিক্ষা প্রতিষ্ঠান মডেল, যা ২১ শতকের দক্ষতা ও প্রযুক্তিনির্ভর শিক্ষাকে কেন্দ্র করে তৈরি করা হয়েছে। ফ্র্যাঞ্চাইজি গ্রহণ করলে আপনি শুধু একটি স্কুল পরিচালনা করবেন না — বরং আপনি পাবেন একটি পূর্ণাঙ্গ সিস্টেম, ব্র্যান্ড ও প্রশিক্ষণভিত্তিক শিক্ষাপ্ল্যাটফর্ম ।
              
            </span>{" "}
          </h2>

          <div className="flex items-start gap-4 mt-4">
            <button
              className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff] bg-[#22beff] text-[#081a28] rounded-md font-medium cursor-pointer hover:text-white"
              onClick={() => window.open(smart_pdf, "_blank")}
            >
              ডাউনলোড
            </button>
            <Link
              to="/qs-academy/smart-school/"
              className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff]  text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff] rounded-md font-medium cursor-pointer"
            >
              বিস্তারিত পড়ুন
            </Link>
          </div>
        </motion.div>

        {/* Image on right */}
        <div className="lg:w-1/2 w-full flex justify-center items-center sm:order-2 order-1">
          <img
            src={image}
            alt="smart_school"
            loading="lazy"
            className="lg:w-[80%] sm:w-[80%] w-[90%] sm:h-[25rem] rounded-xl shadow-[0_0_14px_8px_#22beff]"
          />
        </div>
      </div>
      
    </div>
  );
};

export default FeatureValue1;
